import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-excel-paste-table',
    templateUrl: './excel-paste-table.component.html',
    styleUrls: ['./excel-paste-table.component.scss']
})
export class ExcelPasteTableComponent implements OnInit {

    focused = false;
    columns = [];
    @Input() data = [];

    @Output() onPaste: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
        this.columns = [
            {
                id: 0,
                value: "name"
            },
            {
                id: 1,
                value: "unit"
            },
            {
                id: 2,
                value: "min"
            },
            {
                id: 3,
                value: "max"
            },
        ]
    }

    handlePaste(event: any) {
        const row_data = event.clipboardData.getData('text').split('\n');
        delete row_data[row_data.length - 1];

        const data = [];
        row_data.forEach(item => {
            const row = {};
            this.columns.forEach((a, index) => {
                row[a.value] = item.split('\t')[index].replace(/[\r\n]+/g, '');
            });
            data.push(row);
        });
        this.data = data;
        this.onPaste.emit(this.data);
    }

    handleReset() {
        this.data = [];
    }

    canRenderPasteArea() {
        return !this.data || this.data.length === 0;
    }

    canRenderTable() {
        return this.data && this.data.length > 0;
    }

    onClick() {
        this.focused = true;
    }

    onBlur() {
        this.focused = false;
    }

}
